<app-header sub_titulo="Modificar contenido"></app-header>

<div fxLayout="row" fxLayoutAlign="space-around center" class="grid-container">
  <div class="spinner-overlay" *ngIf="cargandoDatos">
    <div class="spinner-center">
      <mat-spinner
        *ngIf="cargandoDatos"
        diameter="80"
        color="primary"
      ></mat-spinner>
      <label class="input-label" *ngIf="cargandoDatos"
        >&nbsp; Cargando datos...</label
      >
    </div>
  </div>

  <!-- Panel izquierda -->
  <mat-card style="background-color: #f8f8ff; width: 45vw" class="left-column">
    <div *ngIf="this.currentFather" style="overflow: auto; height: 100vh">
      <div
        *ngIf="!answerDisplayed"
        class="card-body-content"
        style="width: 99%"
      >
        <mat-card>
          <button
            *ngIf="this.currentFather && this.currentFather.id !== 'ROOT'"
            style="
              text-align: left;
              width: 100%;
              background-color: #013b82 !important;
            "
            mat-raised-button
            color="primary"
            (click)="loadParent()"
          >
            <svg
              class="arrow"
              version="1.1"
              id="icon"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 32 32"
              style="enable-background: new 0 0 32 32"
              xml:space="preserve"
            >
              <rect id="_Transparent_Rectangle_" />
              <polygon
                points="18,6 16.6,7.4 24.1,15 3,15 3,17 24.1,17 16.6,24.6 18,26 28,16 "
              />
            </svg>
            Elegir otro tema de consulta
          </button>
          <div class="alineacionSuperiorMenu">
            <h5 *ngIf="codigoAsistente" style="font-size: 16px">
              {{ "« " + codigoAsistente + " ~ " + nombreAsistente + " »" }}
            </h5>
          </div>

          <h4 class="titulo-principal mt-2 mb-4 f-22">
            {{
              this.currentFather.name !== "Raiz"
                ? this.currentFather.name
                : "¿Cómo
            puedo ayudarte?"
            }}
          </h4>
          <h5 class="font-weight-normal f-18">
            {{
              this.currentFather.name !== "Raiz"
                ? "Lo más consultado"
                : "Están consultando
            hoy..."
            }}
          </h5>
          <ul class="list-pretty pl-4 mt-3">
            <li *ngFor="let faqNode of currentFAQ">
              <app-config-node
                [habilitado]="true"
                [faqsGlobal]="faqsGlobal"
                (editingModeEmitter)="editingModeEmitterHandler($event)"
                [node]="faqNode"
                (displayAnswerEmitter)="displayAnswer($event)"
              ></app-config-node>
            </li>
          </ul>
          <button
            *ngIf="true"
            mat-raised-button
            color="primary"
            style="background-color: #3f51b5"
            (click)="addFAQNode()"
          >
            Agregar Pregunta Frecuente
          </button>
        </mat-card>
        <br />
        <mat-card>
          <div style="padding-bottom: 10px; padding-top: 10px" *ngIf="true">
            <button
              mat-raised-button
              color="primary"
              (click)="addNode()"
              style="background-color: #3f51b5"
            >
              Agregar Nodo
            </button>
          </div>
          <h5 class="font-weight-normal f-18">
            Elegir un tema para consultar:
          </h5>
          <p>{{ this.currentFather.id === "ROOT" ? "Inicio" : visiblePath }}</p>

          <ul class="list-pretty pl-4 mt-3 mb-0">
            <li *ngFor="let node of displayedNodes">
              <app-config-node
                [habilitado]="true"
                [faqsGlobal]="faqsGlobal"
                (editingModeEmitter)="editingModeEmitterHandler($event)"
                [node]="node"
                (displayAnswerEmitter)="displayAnswer($event)"
                (nodeEmitter)="seleccionarNodo($event)"
                [cantidadNodos]="cantidadNodos"
                [numberOfSiblingsArr]="numberOfSiblingsArr"
                [numberOfSiblingsArrCreation]="numberOfSiblingsArrCreation"
              ></app-config-node>
            </li>
          </ul>
        </mat-card>
        <div
          *ngIf="this.currentFather.id != 'ROOT'"
          id="footer"
          class="card-footer border-0 text-center"
          (click)="returnToStart()"
        >
          <a class="text-white f-13">Volver al Inicio</a>
        </div>
      </div>

      <div *ngIf="answerDisplayed">
        <mat-card>
          <button
            style="
              text-align: left;
              width: 100%;
              background-color: #013b82 !important;
            "
            mat-raised-button
            color="primary"
            (click)="clearAnswerDisplayed()"
          >
            <svg
              class="arrow"
              version="1.1"
              id="icon"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 32 32"
              style="enable-background: new 0 0 32 32"
              xml:space="preserve"
            >
              <rect id="_Transparent_Rectangle_" />
              <polygon
                points="18,6 16.6,7.4 24.1,15 3,15 3,17 24.1,17 16.6,24.6 18,26 28,16 "
              />
            </svg>
            Elegir otro tema de consulta
          </button>
          <div class="card-body bg-white">
            <div class="card-body-content">
              <h4 class="titulo-principal mt-2 mb-4 f-22">
                {{ answerNode.name }}
              </h4>
              <div [innerHtml]="answerNode.answer"></div>

              <div
                id="footer"
                class="card-footer border-0 text-center"
                (click)="returnToStart()"
              >
                <a class="text-white f-13">¿Tenés otra consulta?</a>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </mat-card>

  <!-- Panel derecha -->

  <div class="right-column">
    <mat-card style="background-color: #f8f8ff; width: 45vw">
      <div class="card-body-content">
        <app-editing
          (nodeEmitter)="setNodeBeforeReload($event)"
          (reloadConfig)="loadArbolMenu(idMenu)"
          [faqsGlobal]="faqsGlobal"
          [parentId]="currentFather ? currentFather.id : undefined"
          [parent]="currentFather"
          [editingMode]="editingMode"
          [idMenu]="idMenu"
          [siblingsArr]="displayedNodes"
          [cantidadNodos]="cantidadNodos"
          [numberOfSiblingsArr]="numberOfSiblingsArr"
          [numberOfSiblingsArrCreation]="numberOfSiblingsArrCreation"
          [siblingsArrTmp]="displayedNodes"
        ></app-editing>
      </div>
    </mat-card>
  </div>
</div>
